<template>
  <div class="message">
    <div class="contentCenter">
      <nav class="currentLocation">
        <ul class="display-flex">
          <li>
            <span>您的位置</span>
          </li>
          <li>
            <span>消息中心</span>
          </li>
        </ul>
      </nav>
      <div style="overflow: hidden">
        <ul class="sidebar">
          <li
            v-for="item in sidebar"
            :key="item.id"
            :class="item.className"
            @click="handleSelectedNav(item)"
          >
            <div class="inner display-flex justify-content-space-between">
              <span>{{ item.name }}</span>
              <img src="../../assets/img/arrowLeft.png" alt />
            </div>
          </li>
        </ul>
        <router-view />
      </div>
    </div>
  </div>
</template>

<script>
import { postData, showLoading, EventBus } from "../../assets/api/api.js";
export default {
  name: "message",
  components: {},
  data() {
    return {
      sidebar: [
        {
          id: 0,
          name: "系统消息",
          className: "active",
          url: "/message/msgList",
        },
      ],
    };
  },
  created() {},
  watch: {},
  mounted() {},
  computed: {},
  methods: {
    handleSelectedNav(item) {
      this.$router.push({ path: item.url });
      this.sidebar.forEach((i) => {
        if (item.id == i.id) {
          i.className = "active";
        } else {
          i.className = "";
        }
      });
    },
  },
};
</script>
<style lang="scss">
.ivu-tabs-nav {
  margin-left: 20px;
}
.ivu-tabs-nav .ivu-tabs-tab {
  // margin-right: 37px;
  font-size: 16px;
  color: rgba(153, 153, 153, 1);
  line-height: 20px;
  padding: 20px 8px;
}
.ivu-tabs-nav .ivu-tabs-tab-active {
  color: #222222 !important;
  color: rgba(34, 34, 34, 1);
}
.ivu-tabs-ink-bar {
  background: #222222;
  height: 3px;
}
</style>
<style lang="scss" scoped>
.message {
  .publicTitle {
    margin-bottom: 0;
    h5 {
      cursor: pointer;
    }
  }
  .detail {
    margin-top: 30px;
    min-height: 420px;
  }
  .msgDetail {
    margin-bottom: 30px;
    width: 962px;
    float: right;
    background: #fff;
    padding: 0 20px;
  }
  .list {
    margin-bottom: 30px;
    width: 962px;

    float: right;
    background: #fff;
    padding: 0 20px;
  }
  .msgList {
    min-height: 400px;
    .item:hover {
      p,
      .time {
        color: #ec6941;
      }
    }
    // .item.active {
    //   p,
    //   .time {
    //     color: #ec6941;
    //   }
    // }
    .item {
      cursor: pointer;
      border-bottom: 1px dashed #d9d6d9;
      line-height: 75px;
      p {
        color: #666;
        padding-right: 30px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .time {
        display: inline-block;
        width: 110px;
        color: rgba(204, 204, 204, 1);
      }
    }
  }
}
</style>
